<template>
  <div class="account">
    <el-form
      style="padding-top: 10px;margin-left: 18px;margin-bottom:15px;width: 98%"
      :inline="true"
    >
      <router-link to="/home/performance/generate">
        <el-button type="primary">+生成评估单</el-button>
      </router-link>
      <div style="float: right; display: inline-block">
        <el-date-picker
          v-model="chartTimeValue"
          type="daterange"
          :clearable="false"
          unlink-panels
          align="center"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-form-item>
          <el-button type="primary" class="el-icon-search" @click="inquire"></el-button>
        </el-form-item>
      </div>
    </el-form>
    <template>
      <el-table
        border
        :data="tableData"
        stripe
        style="width: 98%;margin-left: 18px"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column type="index" label="序号" width="auto"></el-table-column>
        <el-table-column prop="assessor" label="评估人"></el-table-column>
        <el-table-column prop="assessed" label="被评估人"></el-table-column>
        <el-table-column prop="leaderEvaluation" label="领导评价"></el-table-column>
        <el-table-column prop="selfEvaluation" label="自我评价"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.assessedId == uid"
              @click="compile(scope.row)"
              type="warning"
              size="mini"
            >更新自我评价</el-button>
            <el-button v-else disabled="disabled" type="warning" size="mini">更新自我评价</el-button>
            <el-button
              v-if="scope.row.assessorId == uid"
              @click="leadership(scope.row)"
              type="primary"
              size="mini"
            >更新领导评价</el-button>
            <el-button v-else disabled="disabled" type="primary" size="mini">更新领导评价</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <el-dialog title="自我评价" :visible.sync="dialogTableVisible">
      <el-form label-position="left">
        <el-form-item label="请输入自我评价:">
          <el-input v-model="selfEvaluation"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更改领导评价" :visible.sync="dialogTable">
      <el-form label-position="left">
        <el-form-item label="请输入更改领导评价:">
          <el-input v-model="leadEvaluate"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTable = false">取 消</el-button>
        <el-button type="primary" @click="leader">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from "../../common/date";
export default {
  data() {
    return {
      dialogTable: false,
      dialogTableVisible: false,
      options: [],
      value5: [],
      value: "",
      chartTimeValue: [Date.now(), Date.now()],
      tableData: [],
      rowId: "",
      selfEvaluation: "",
      leadEvaluate: "",
      uid: ""
    };
  },
  methods: {
    leader() {
      this.$axios({
        url: "/api/performance/leader/" + this.rowId + "/" + this.leadEvaluate,
        method: "PUT"
      })
        .then(res => {
          if (res.status == 200) {
            this.$message({
              message: "领导评价更新成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "领导评价更新失败",
              type: "error"
            });
          }
          this.formDataMenu();
          this.dialogTable = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    confirm() {
      this.$axios({
        url: "/api/performance/self/" + this.rowId + "/" + this.selfEvaluation,
        method: "PUT"
      })
        .then(res => {
          if (res.status == 200) {
            this.$message({
              message: "自我评价更新成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "自我评价更新失败",
              type: "error"
            });
          }
          this.formDataMenu();
          this.dialogTableVisible = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    leadership(row) {
      this.dialogTable = true;
      this.rowId = row.id;
    },
    compile(row) {
      this.dialogTableVisible = true;
      this.rowId = row.id;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#f2f2f2;color: #a4a7af;";      }
    },
    getLi() {
      let tV = this.chartTimeValue;
      if (!tV) {
        this.$message({
          message: "请将日期填写完整",
          type: "warning"
        });
        return;
      }
      let start = formatDate(this.chartTimeValue[0], "yyyy-MM-dd");
      let end = formatDate(this.chartTimeValue[1], "yyyy-MM-dd");
      this.$axios({
        url: "/api/performance/" + start + "/" + end,
        method: "GET"
      })
        .then(res => {
          this.tableData = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    inquire() {
      this.getLi();
    },
    generate() {
      if (this.value5.length == 0) {
        this.$message({
          message: "请将信息选择完整",
          type: "warning"
        });
        return;
      }
      if (this.value == "") {
        this.$message({
          message: "请将信息选择完整",
          type: "warning"
        });
        return;
      }
      if (this.chartTimeValue.length == 0) {
        this.$message({
          message: "请将信息选择完整",
          type: "warning"
        });
        return;
      }
      this.$axios({
        url: "/api/performance",
        method: "POST",
        data: {
          assessedIds: this.value5,
          assessorId: this.value,
          startDate: formatDate(this.chartTimeValue[0], "yyyy-MM-dd"),
          endDate: formatDate(this.chartTimeValue[1], "yyyy-MM-dd")
        }
      })
        .then(res => {
          if (res.status == 200) {
            this.$message({
              message: "生成成功",
              type: "success"
            });
            this.formDataMenu();
          } else {
            this.$message({
              message: "生成失败",
              type: "warning"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    formDataMenu() {
      let start = formatDate(this.chartTimeValue[0], "yyyy-MM-dd");
      let end = formatDate(this.chartTimeValue[1], "yyyy-MM-dd");
      // 生成表单数据
      this.$axios({
        url:
          "/api/performance/" +
          formatDate(this.chartTimeValue[0], "yyyy-MM-dd") +
          "/" +
          formatDate(this.chartTimeValue[1], "yyyy-MM-dd"),
        method: "GET"
      })
        .then(res => {
          this.tableData = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.query.endDate != undefined) {
        vm.chartTimeValue[0] = parseInt(to.query.startDate);
        vm.chartTimeValue[1] = parseInt(to.query.endDate);
        vm.formDataMenu();
        vm.getLi();
      }
    });
  },
  created: function() {
    this.uid = localStorage.uid;
    this.getLi();
  }
};
</script>

<style scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
#charg {
  width: 100%;
  padding-bottom: 50px;
  background-color: white;
}

.block {
  margin-top: 20px;
  padding-left: 33%;
}

.charg_p {
  border-bottom: 1px solid #e7e7e7;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.68);
  line-height: 70px;
  padding: 0 20px 0 10px;
}

.charg_p div {
  display: inline-block;
}

.right {
  float: right;
}

.inputclass {
  width: 200px !important;
}
</style>
 


// WEBPACK FOOTER //
// performanceLi.vue?7f2230b0